import axios from "axios";
import Cookies from "universal-cookie";
import CustomModal from "../components/reusablemodal/CustomModal";
import { createRoot } from "react-dom/client";

// Loader connection (from MyCustomLoader.jsx)
let loaderStore;
export const setLoaderStore = (loader) => {
  loaderStore = loader;
};

export const cookies = new Cookies();

// ******************* Importent *******************
// Google Console Project name : Holy Bharat - for Google OAuth 2.0 Client IDs
// Google Console Project name : Gemini API - for Gemini API Key
// Google Console Project name : My First Project - for Google Map
export const GOOGLE_MAPS_API_KEY = "AIzaSyDkJZ13LU2asYWcQRYYU5KZAELtMMtWzUM";

export const DEFAULT_CENTER = { lat: 13.0827, lng: 80.2707 };

// export const linkedInRedirectUrl = "http://localhost:3000/";
export const linkedInRedirectUrl = "https://dev.holybharat.com/";
// export const linkedInRedirectUrl = "https://test.holybharat.com/";

const AxiosInstance = axios.create({
  // baseURL: "http://192.168.0.112:8083/api/",
  baseURL: "https://dev.holybharat.com/api/",
  // baseURL: "https://test.holybharat.com/api/",
});

const RELEASE_NO = "0.0.1";

// ✅ Track active requests to avoid double loader
let activeRequests = 0;
// ------------- Function to show login required modal -------------
const showLoginRequiredModal = () => {
  let modalContainer = document.getElementById("login-required-modal");
  if (!modalContainer) {
    modalContainer = document.createElement("div");
    modalContainer.id = "login-required-modal";
    document.body.appendChild(modalContainer);
  }

  const root = createRoot(modalContainer);

  const handleClose = () => {
    root.unmount();
    window.location.href = "/login"; // redirect to login after closing
  };

  root.render(
    <CustomModal
      show={true}
      handleClose={null} // disable X button
      title="Website Update Required"
      secondaryButtonLable={null} // no secondary button
      primaryButtonLable="Reload Now"
      renderModalContent="A new version of the Divine Journey website is available. Please reload the page to enjoy the latest updates and continue your seamless experience."
      secondaryClick={null}
      primaryClick={handleClose}
      backdrop="static" // prevent outside click
      keyboard={false} // disable Esc key
    />
  );
};

// ------------- Function to show modal -------------
const showNetworkTimeoutModal = () => {
  let modalContainer = document.getElementById("network-timeout-modal");
  if (!modalContainer) {
    modalContainer = document.createElement("div");
    modalContainer.id = "network-timeout-modal";
    document.body.appendChild(modalContainer);
  }

  const root = createRoot(modalContainer);

  const handleClose = () => {
    root.unmount();
    window.location.reload(); // refresh page
  };

  root.render(
    <CustomModal
      show={true}
      handleClose={null} // disable X button
      title={null}
      secondaryButtonLable={null} // no secondary button
      primaryButtonLable="OK"
      renderModalContent="A network error occurred. Click OK to refresh the page."
      secondaryClick={null}
      primaryClick={handleClose}
      backdrop="static" // prevent outside click
      keyboard={false} // disable Esc key
    />
  );
};

// ---------------- Request Interceptor ----------------
AxiosInstance.interceptors.request.use(
  (config) => {
    activeRequests++;
    // ✅ Pass the API URL to the loader
    const url = config.url || '';
    if (loaderStore) loaderStore.setLoading(true, url);

    const UserDetails = cookies.get("userDetails"); // from cookies now

    if (UserDetails) {
      if (UserDetails.user_id) {
        config.headers[
          "Authorization"
        ] = `Bearer ${UserDetails.token} ${UserDetails.user_id} ${RELEASE_NO}`;
      }
    }
    return config;
  },
  (error) => {
    activeRequests = Math.max(activeRequests - 1, 0);
    // ✅ Pass the API URL to the loader
    const url = error?.config?.url || '';
    if (activeRequests === 0 && loaderStore) loaderStore.setLoading(false, url);
    return Promise.reject(error);
  }
);

// ---------------- Response Interceptor ----------------
AxiosInstance.interceptors.response.use(
  (response) => {
    activeRequests = Math.max(activeRequests - 1, 0);
    // ✅ Pass the API URL to the loader
    const url = response?.config?.url || '';
    if (activeRequests === 0 && loaderStore) loaderStore.setLoading(false, url);
    return response;
  },
  (error) => {
    activeRequests = Math.max(activeRequests - 1, 0);
    // ✅ Pass the API URL to the loader
    const url = error?.config?.url || '';
    if (activeRequests === 0 && loaderStore) loaderStore.setLoading(false, url);

    if (error.response) {
      const status = error.response.status;
      if (status === 401 || status === 403) {
        localStorage.removeItem("userDetails");
        cookies.remove("userDetails", { path: "/" });
        localStorage.removeItem("appLanguage");
        window.location.href = "/login";
      } else if (status === 426) {
        showLoginRequiredModal();
        localStorage.removeItem("userDetails");
        cookies.remove("userDetails", { path: "/" });
        localStorage.removeItem("appLanguage");
        // window.location.href = "/login";
      } else if (status === 504) {
        showNetworkTimeoutModal(); // show modal directly
      } else {
        console.log("Unhandled Error:", error);
      }
    } else if (!error.response || error.code === "ERR_NETWORK") {
      // network failure
      showNetworkTimeoutModal();
    }

    return Promise.reject(error);
  }
);

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB");
};

export const formatTime = (timeString) => {
  if (!timeString) return "";
  const [hours, minutes] = timeString.split(":");
  const date = new Date();
  date.setHours(parseInt(hours), parseInt(minutes));
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export { AxiosInstance };